import React from 'react'

function Ricaricabile() {
    return (
        <div>
            <p className='info'>Ogni volta che il tuo saldo, comprensivo dei consumi quotidiani, va sotto la soglia impostata, ricaricheremo la taglia scelta dal tuo metodo di pagamento preferito.</p>
            <div className="column">
                <div className="customRow">
                    <p className='main'>Cosa paghi?</p>
                    <span className="separ"></span>
                    <p className='secondary'>Prezzo al kWh tutto incluso x consumi giornalieri.</p>
                </div>
                <div className="customRow">
                    <p className='main'>Hai sconti?</p>
                    <span className="separ"></span>
                    <p className='secondary'>Si! Per tutti i consumi giornalieri con saldo a credito</p>
                </div>
                <div className="customRow">
                    <p className='main'>Quando paghi i consumi del mese?</p>
                    <span className="separ"></span>
                    <p className='secondary'>Preleveremo la taglia che hai scelto ogni volta che il tuo Saldo scende sotto la soglia preimpostata.</p>
                </div>
            </div>
        </div>
    )
}

export default Ricaricabile
